<template>
  <div class="business_data">
    <page-box :title="'销量数据'">
      <div class="content">
        <div class="switch_box">
          <div
            :class="['item', selIndex == index ? 'active' : '']"
            v-for="(item, index) in switchData"
            :key="index"
            @click="selEcharts(index)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="overview">
          <div class="item" v-for="(item, index) in data" :key="index">
            <img :src="item.icon" alt="" class="icon" />
            <div class="text_content">
              <div class="number_content">
                <div class="number">{{ item.number }}</div>
                <div class="fon">{{ item.fon }}</div>
              </div>
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <div class="echarts_content">
          <my-echarts :options="OverViewEcharts"></my-echarts>
        </div>
      </div>
    </page-box>
  </div>
</template>

<script setup>
import PageBox from '@/components/pageBox/PageBox';
import { ref, reactive, onMounted } from 'vue';
import MyEcharts from '@/baseCpm/MyEcharts/MyEcharts.vue';
import * as echarts from 'echarts';
const switchData = reactive([
  {
    name: '累计',
    id: 0,
  },
  {
    name: '今年',
    id: 1,
  },
]);

const data = reactive([
  {
    name: '黑鱼片',
    number: 5.45,
    icon: require('@/assets/images/Industry/contract.png'),
    fon: '亿',
  },
  {
    name: '酸菜鱼',
    number: 1200,
    icon: require('@/assets/images/Industry/enterprise.png'),
    fon: '',
  },
  {
    name: '脆肉皖鱼',
    number: 890,
    icon: require('@/assets/images/Industry/exit.png'),
    fon: '',
  },
]);

let selIndex = ref(0);
const selEcharts = (index) => {
  if (selIndex.value !== index) {
    selIndex.value = index;
    getOverViewEcharts();
  }
};
let OverViewEcharts = ref(null);
// 累计数据
let enterTotalData = [1000, 900, 800, 830, 950, 800, 750, 500, 400, 300];
let leaveTotalData = [400, 380, 370, 500, 600, 750, 800, 780, 800, 1000];
// 今年数据
let enterYearData = [1000, 900, 800, 830, 950, 800, 750, 500, 400, 300];
let leaveYearData = [400, 380, 370, 500, 600, 750, 800, 780, 800, 1000];
const getOverViewEcharts = () => {
  let xAxisData = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月'];
  let series = [
    {
      type: 'line',
      name: '入驻',
      symbol: 'none',
      smooth: false,
      data: selIndex.value == 0 ? enterTotalData : enterYearData,
      itemStyle: {
        // rgba(24, 177, 254, 1)
        color: 'rgba(24, 177, 254, 1)',
        width: 6,
      },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: 'rgba(24, 177, 254, 0.6)',
          },
          {
            offset: 1,
            color: 'rgba(24, 177, 254, 0.1)',
          },
        ]),
      },
    },
    {
      type: 'line',
      name: '退园',
      symbol: 'none',
      smooth: false,
      data: selIndex.value == 0 ? leaveTotalData : leaveYearData,
      itemStyle: {
        color: 'rgba(253, 255, 148, 1)',
        width: 6,
      },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: 'rgba(253, 255, 148, 0.6)',
          },
          {
            offset: 1,
            color: 'rgba(253, 255, 148, 0.1)',
          },
        ]),
      },
    },
  ];
  OverViewEcharts.value = {
    legend: {
      top: '0',
      left: 'right',
      itemWidth: 12,
      itemHeight: 12,
      icon: 'rect',
      itemGap: 14,
      textStyle: {
        rich: {
          a: {
            fontFamily: 'MiSans',
            fontSize: 11.8,
            lineHeight: 12,
            padding: [0, 0, 0, 4],
            color: 'rgba(239, 233, 255, 1)',
          },
        },
      },
      formatter: function (params) {
        let data = series;
        let fil = '';
        let value = 0;
        let all = 0;
        for (let i = 0; i < data.length; i++) {
          if (data[i].name == params) {
            fil += '{a|' + params + '}';
          }
        }

        return fil;
      },
    },
    grid: {
      top: '25%',
      left: '13%',
      right: '2%',
      bottom: '20%',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'line',
      },
      renderMode: 'html',
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      borderWidth: 0, // 提示框浮层的边框宽。
      padding: [6, 23],
      textStyle: {
        // 提示框浮层的文本样式。
        color: '#fff',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontFamily: 'OPPOSans,serif',
        fontSize: 11.8,
      },
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
      boundaryGap: false,
      axisPointer: {
        type: 'shadow',
      },

      axisLabel: {
        formatter: '{value}',
        fontSize: 11.8,
        lineHeight: 14,
        color: 'rgba(24, 177, 254, 1)',
        fontFamily: 'MiSans',
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255,255,255,0.1)',
          type: 'dashed',
          width: 1,
        },
      },
    },
    yAxis: {
      type: 'value',
      name: `家`,
      min: 0,
      max: 1000,
      interval: 500,
      nameTextStyle: {
        fontFamily: 'MiSans',
        fontSize: 11.8,
        lineHeight: 14,
        color: 'rgba(24, 177, 254, 1)',
      },
      axisLabel: {
        formatter: '{value}',
        fontSize: 11.8,
        lineHeight: 14,
        color: 'rgba(24, 177, 254, 1)',
        fontFamily: 'MiSans',
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255,255,255,0.1)',
          type: 'dashed',
          width: 1,
        },
      },
    },
    series: series,
  };
};

onMounted(() => {
  getOverViewEcharts();
});
</script>

<style lang="scss" scoped>
.business_data {
  margin-bottom: 5px;
  .content {
    margin-left: 20px;
    width: 310px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .switch_box {
      padding-left: 28px;
      box-sizing: border-box;
      // margin-top: 8px;
      display: flex;
      width: 285px;
      height: 23.93px;
      background-size: 100% 100%;
      background-image: url(@/assets/images/Situation/switch_bg.png);
      margin-bottom: 25px;
      .item {
        cursor: pointer;
        width: 77.76px;
        height: 23.93px;
        background-size: 100% 100%;
        background-image: none;
        text-align: center;
        color: #e4efff;
        font-family: MiSans;
        font-size: 12.66px;
        font-style: normal;
        font-weight: 400;
        line-height: 23.93px;
        letter-spacing: -0.288px;
        &.active {
          font-family: 'MiSansS';
          background-image: url(@/assets/images/Situation/active_bg.png);
        }
      }
    }
    .overview {
      margin-left: 20px;
      width: 310px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .item {
        // width: 92px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .icon {
          width: 27px;
          height: 32px;
          flex-shrink: 0;
          margin-right: 6px;
        }
        .text_content {
          flex-grow: 1;
          .number_content {
            display: flex;
            justify-content: flex-start;
            align-items: baseline;
            margin-bottom: 6px;
            .number {
              color: #ffec90;
              font-family: MiSansS;
              font-size: 15px;
              font-style: normal;
              font-weight: 600;
              line-height: 18px; /* 100% */
              margin-right: 2px;
            }
            .fon {
              color: rgba(255, 236, 144, 0.7);
              font-family: MiSans;
              font-size: 11px;
              font-style: normal;
              font-weight: 400;
              line-height: 19.2px; /* 137.143% */
            }
          }
          .name {
            min-width: 60px;
            color: #18b1fe;
            font-family: MiSans;
            font-size: 10.97px;
            font-style: normal;
            font-weight: 400;
            line-height: 19.2px; /* 128% */
          }
        }
      }
    }
    .echarts_content {
      width: 310px;
      height: 120px;
    }
  }
}
</style>
